import { prop, propObject } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { CountryRegion } from "./country-region";

export class Address extends Resource {
    public override type = 'addresses';

    @prop()
    public addressLine1!: string;
    @prop()
    public addressLine2!: string;
    @prop()
    public city!: string;
    @prop()
    public zipCode!: string;
    @prop()
    public countryCode!: string;
    @prop()
    public countryRegionId!: string;

    @propObject()
    public countryRegion?: CountryRegion;
    
    @prop()
    public latitude?: number;
    @prop()
    public longitude?: number;

    //distancia en km a la capital de la provincia, la calcula el backend: el frontend nunca la escribe
    public distanceToCityCenter?: number;

    public fullAddress!: string;
}